"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidForTooltip = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ValidForTooltip = (isGlobal, title, validForItems) => {
    if (isGlobal) {
        if (typeof title === 'string') {
            const titleString = title.split(':');
            return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { className: "subtitle-lg-moderate", children: [titleString[0], ":"] }), (0, jsx_runtime_1.jsx)("div", { className: "body-md text-secondary", children: titleString[1] })] }));
        }
        return (0, jsx_runtime_1.jsx)("div", { className: "subtitle-lg-moderate", children: title });
    }
    if (!validForItems || !validForItems.length) {
        return;
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: "subtitle-lg-moderate", children: title }), (0, jsx_runtime_1.jsx)("div", { className: "body-md text-secondary", children: validForItems.filter(item => item.trim() !== '').join(', ') })] }));
};
exports.ValidForTooltip = ValidForTooltip;
